var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.files && _vm.files.length
    ? _c("div", { staticClass: "file-list-wrapper" }, [
        _c(
          "ul",
          { staticClass: "el-upload-list el-upload-list--text" },
          _vm._l(_vm.files, function (f, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "el-upload-list__item is-success",
                attrs: { tabindex: "0" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "el-upload-list__item-name",
                    attrs: { href: _vm.getfileUrl(f.url), target: "_blank" },
                    on: {
                      click: function ($event) {
                        return _vm.handledownload(f.url, f.name)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v(_vm._s(f.name) + " "),
                  ]
                ),
                _vm._m(0, true),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "el-upload-list__item-status-label" }, [
      _c("i", { staticClass: "el-icon-upload-success el-icon-circle-check" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }